import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid';

export enum CustomActionsCellTypes {
  ADMINS = 'admins',
  EMPLOYEES = 'employees',
  STUDIOS = 'studios',
  SERVICES = 'services',
  BOOKINGS = 'bookings',
}

export type CustomActionsCellProps = {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>;
  type: CustomActionsCellTypes;
};
